import CaretDownOutlined from '@ant-design/icons/CaretDownOutlined';
import { useGetAccounts } from '@vindr/services/actions/account.action';
import { ParamsGetAccount } from '@vindr/services/apis/account.api';
import { DEBOUNCE_WAIT } from '@vindr/services/constants/common.constant';
import { USER_STATUS } from '@vindr/services/constants/filter.constant';
import { filterValidValue, uniquePushArray } from '@vindr/utils/helpers/common.helper';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { DefaultOptionType } from 'antd/es/select';
import { debounce } from 'lodash';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormItem from '../FormItem';
import { FormSelectProps } from '../templates/FormSelect';

interface Technician extends FormSelectProps {
  institutions?: string[];
  selected: DefaultOptionType;
}

const Technician = ({
  name = 'technician_id',
  label = 'Technician',
  placeholder = 'Select technician',
  rules,
  required = true,
  onChange,
  disabled,
  multiple,
  institutions,
  selected,
  ...props
}: Technician) => {
  const { t } = useTranslation('Vindoc');
  const [searchValue, setSearchValue] = useState('');

  const { data, isInitialLoading } = useGetAccounts({
    offset: 0,
    limit: 100,
    statuses: [USER_STATUS.ACTIVE],
    ...filterValidValue<ParamsGetAccount>(
      { username: searchValue },
      { invalidList: [null, undefined, ''] }
    ),
  });

  const accounts = useMemo(() => {
    return data?.data;
  }, [data?.data]);

  const rulesMemo = useRoleMemo({ required, rules, disabled });

  const debouncedSearch = useCallback(
    debounce((searchText) => {
      setSearchValue(searchText);
    }, DEBOUNCE_WAIT),
    []
  );

  const handleSearch = useCallback(
    (searchText) => {
      debouncedSearch(searchText);
    },
    [debouncedSearch]
  );

  return (
    <FormItem.Select
      name={name}
      label={label}
      size="small"
      wrapperClassName="w-full"
      className="w-full"
      placeholder={t(placeholder)}
      suffixIcon={<CaretDownOutlined />}
      disabled={disabled}
      showSearch
      onSearch={handleSearch}
      loading={isInitialLoading}
      rules={rulesMemo}
      options={uniquePushArray<DefaultOptionType>(
        accounts?.map((user) => ({
          value: user?.id,
          label: user?.fullname || user?.username,
        })),
        selected
      )}
      listHeight={200} //? Fix when search, accounts long make dropdown position on top
      {...props}
    />
  );
};

export default Technician;
